import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Box,
  Button,
  Grid,
  Card,
  CardContent,
  Stack,
  IconButton,
  Tooltip,
  Link,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LandingPageLayoutDesktop from '../../layout/LandingPageLayoutDesktop';
import { Person, PersonAdd, MenuBook } from '@mui/icons-material';
import logoImg from '../../assets/logo.png';

export default function DeskStudioLandingPageDesktopRev() {
  const navigate = useNavigate();

  return (
    <LandingPageLayoutDesktop>
      {/* HERO */}
      <Box
        id="hero"
        sx={{
          py: 12,
          textAlign: 'center',
          background: '#fff',
          color: '#2742F5',
        }}
      >
        <img src={logoImg} alt="DeskStudio" style={{ maxWidth: '140px', marginBottom: '24px' }} />
        <Typography variant="h2" sx={{ mb: 2, fontWeight: 700 }}>
          DeskStudio
        </Typography>
        <Typography variant="h5" sx={{ mb: 4 }}>
          Il gestionale delle scadenze fiscali pensato per studio e contribuenti (partite IVA individuali)
        </Typography>
        <Typography variant="h6" sx={{ mb: 4 }}>
          Scadenze fiscali sotto controllo, senza stress. Più tempo per altre attività
        </Typography>
        <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }} justifyContent="center">
          <Tooltip title="Accedi">
            <IconButton sx={{ bgcolor: '#2742F5', color: '#fff', '&:hover': { bgcolor: '#1B34D1' } }} onClick={() => navigate('/login')} size="large">
              <Person />
            </IconButton>
          </Tooltip>
          <Tooltip title="Registrati">
            <IconButton sx={{ bgcolor: '#2742F5', color: '#fff', '&:hover': { bgcolor: '#1B34D1' } }} onClick={() => navigate('/register')} size="large">
              <PersonAdd />
            </IconButton>
          </Tooltip>
          <Tooltip title="Manuale utente">
            <IconButton
              sx={{ bgcolor: '#2742F5', color: '#fff', '&:hover': { bgcolor: '#1B34D1' } }}
              onClick={() => window.open(`${process.env.PUBLIC_URL}/manualeUtente.pdf`, '_blank')}
              size="large"
            >
              <MenuBook />
            </IconButton>
          </Tooltip>
        </Stack>
        <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }} justifyContent="center" sx={{ mt: 2 }}>
          <Button onClick={() => navigate('/privacy')} sx={{ color: '#2742F5' }}>
            Privacy
          </Button>
          <Button onClick={() => navigate('/terms')} sx={{ color: '#2742F5' }}>
            Termini e Condizioni
          </Button>
        </Stack>
      </Box>

      {/* PROBLEMA */}
      <Container id="problema" sx={{ py: 10 }}>
        <Typography variant="h4" sx={{ mb: 3, textAlign: 'center', color: '#2742F5' }}>
          Sai sempre dove sono le tue scadenze o quelle dei tuoi clienti?
        </Typography>
        <Typography variant="h6" sx={{ mb: 5, textAlign: 'center', color: '#2742F5' }}>
          Documenti sparsi, scadenze perse, telefonate infinite. DeskStudio organizza tutto in un unico posto.
        </Typography>
      </Container>

      {/* SOLUZIONI */}
      <Box id="soluzioni" sx={{ bgcolor: '#fff', py: 10 }}>
        <Container>
          <Typography variant="h4" sx={{ mb: 4, textAlign: 'center', color: '#2742F5' }}>
            Cosa fa DeskStudio
          </Typography>
          <Grid container spacing={4}>
            {[
              { title: 'Documenti centralizzati', desc: 'PDF e allegati organizzati in un unico posto' },
              { title: 'Scadenze sotto controllo', desc: 'Tutte le rate e scadenze in un colpo d’occhio' },
              { title: 'Accesso cliente facile', desc: 'Carica i tuoi documenti senza stress' },
              { title: 'Marcatura pagamento rapida', desc: 'Segna pagamenti con un click' },
              { title: 'Avvisi automatici', desc: 'Ricevi notifiche sulle scadenze in arrivo' },
              { title: 'Sicurezza', desc: 'Autenticazione a due fattori (OTP), storage dei dati su S3, hashing' },
              { title: 'Report e statistiche', desc: 'Visibilità completa senza conti manuali' },
            ].map((f, idx) => (
              <Grid item xs={12} sm={6} md={4} key={idx}>
                <Card sx={{ p: 3, height: '100%', borderRadius: 3, boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
                  <CardContent>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                      {f.title}
                    </Typography>
                    <Typography>{f.desc}</Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* TESTIMONIANZE */}
      <Container id="testimonianze" sx={{ py: 10 }}>
        <Typography variant="h4" sx={{ mb: 5, textAlign: 'center', color: '#2742F5' }}>
          Cosa dicono i nostri clienti
        </Typography>
        <Grid container spacing={4} justifyContent="center">
          {[
            '“Con DeskStudio ho finalmente la visione completa dei documenti dei miei clienti. Risparmio 3 ore a settimana!” – Marco',
            '“Mai più scadenze perse, il mio studio è finalmente organizzato.” – Laura',
          ].map((t, idx) => (
            <Grid item xs={12} md={6} key={idx}>
              <Card sx={{ p: 3, bgcolor: '#ffe0b2', borderRadius: 3, boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
                <Typography variant="body1">{t}</Typography>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* PREZZI */}
      <Box id="prezzi" sx={{ bgcolor: '#fff', color: '#000', py: 10 }}>
        <Container>
          <Typography variant="h6" sx={{ mb: 5, textAlign: 'center' }}>
            Prezzi chiari e accessibili. Per ogni opzione di abbonamento sono possibili sconti. Gli abbonamenti 'Studio XX' e
            'Plus' forniscono l'accesso alla applicazione con il profilo "STUDIO', per la gestione dei fascicoli dei
            contribuenti (Partite IVA individuali). L'abbonamento Single è dedicato al singolo CONTRIBUENTE che vuole
            gestire in autonomia il suo fascicolo, e/o interagire con uno STUDIO. I contribuenti associati a uno studio
            possono gestire il loro fascicolo usufruendo per il primo anno di un canone annuo 'Single' con uno sconto di
            60€. Lo studio a sua volta avrà uno sconto di 10€ per ogni suo contribuente che sottoscrive l' abbonamento
            single. Lo sconto sarà applicato al primo rinnovo di contratto. L'associazione di un contribuente ad uno studio
            avviene inserendo nel form di registrazione il codice invito fornito loro dallo studio.
          </Typography>

          <Typography variant="h4" sx={{ mb: 5, textAlign: 'left' }}>
            <Typography>Perchè acquistare DeskStudio?</Typography>
            <Typography>- funzionalità potenti ma semplici</Typography>
            <Typography>- risolve i vostri problemi</Typography>
            <Typography>- è un prodotto nuovo in continua evoluzione che acquisirà nuove funzionalità, anche su proposta degli utenti.</Typography>
          </Typography>

          <Grid container spacing={4} justifyContent="center">
            {[
              { plan: 'Base', price: '129€/anno', desc: '1 contribuente' },
              { plan: 'Studio 10', price: '349€/anno', desc: 'Fino a 10 contribuenti gestiti' },
              { plan: 'Studio 20', price: '549€/anno', desc: 'Fino a 20 contribuenti gestiti' },
              { plan: 'Studio 50', price: '899€/anno', desc: 'Fino a 50 contribuenti gestiti' },
              { plan: 'Studio 150', price: '1799€/anno', desc: 'Fino a 150 contribuenti gestiti' },
              { plan: 'Studio Plus', price: '2799€/anno', desc: 'Illimitati' },
            ].map((p, idx) => (
              <Grid item xs={12} sm={6} md={3} key={idx}>
                <Card sx={{ p: 3, textAlign: 'center', bgcolor: '#fff', color: '#000', borderRadius: 3, boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
                  <Typography variant="h6">{p.plan}</Typography>
                  <Typography variant="h4" sx={{ my: 2 }}>
                    {p.price}
                  </Typography>
                  <Typography sx={{ mb: 2 }}>{p.desc}</Typography>
                  <Tooltip title="Registrati">
                    <IconButton                       sx={{ bgcolor: '#2742F5', color: '#fff', '&:hover': { bgcolor: '#1B34D1' } }} onClick={() => navigate('/sitopubblico/demorequest')}>
                      <PersonAdd />
                    </IconButton>
                  </Tooltip>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>

        {/* CONTATTI */}
        <Container id="contatti" sx={{ py: 10 }}>
          <Typography variant="h4" sx={{ mb: 3, textAlign: 'center', color: '#000000' }}>
            Contattaci su:
          </Typography>
          <Typography variant="h5" sx={{ mb: 3, textAlign: 'center', color: '#000000' }}>
            <Link href="mailto:info@deskstudio.it" color="inherit" underline="always">
              info@deskstudio.it
            </Link>
          </Typography>
        </Container>
      </Box>

      {/* FOOTER */}
      <Box sx={{ bgcolor: '#333', color: '#fff', py: 3, textAlign: 'center' }}>
        <Typography variant="body2">DeskStudio © 2026</Typography>
      </Box>
    </LandingPageLayoutDesktop>
  );
}
